import { TFunction } from 'i18next';
import { object } from 'yup';

import { makeNewPassword } from 'src/shared/validationSchemas';

const makeValidationSchema = (t: TFunction) =>
  object().shape({
    password: makeNewPassword(t),
  });

export { makeValidationSchema };
